<template>
  <v-card class="platform-card" elevation="0">
    <div class="platform-header">
      <div class="header-row">
        <div class="header-icon"><v-icon color="white" size="18">mdi-account-group</v-icon></div>
        <span class="header-title">{{ $t('pages.platform_users') }}</span>
      </div>
    </div>
    <v-card-text class="pa-3 pa-sm-4">
      <v-row dense>
        <v-col v-for="item in items" :key="item.label" cols="12" sm="6">
          <div class="user-stat-row" :style="{ borderLeft: '3px solid ' + item.color }" @click="openDialog(item)">
            <div class="user-stat-icon" :style="{ background: item.color + '18' }">
              <v-icon :color="item.color" size="20">{{ item.icon }}</v-icon>
            </div>
            <div class="user-stat-info">
              <div class="user-stat-label">{{ item.label }}</div>
              <div class="user-stat-value" :style="{ color: item.color }">
                <span v-if="loading">—</span>
                <span v-else>{{ item.total }}</span>
              </div>
            </div>
            <div class="user-stat-badge">
              <v-chip x-small :color="item.color" outlined>
                <v-icon left x-small>mdi-login</v-icon>
                {{ item.todayLogins }} sot
              </v-chip>
            </div>
            <v-icon size="14" color="grey lighten-1">mdi-chevron-right</v-icon>
          </div>
        </v-col>
      </v-row>
    </v-card-text>

    <!-- Users Dialog — fullscreen on mobile -->
    <v-dialog v-model="dialog" :max-width="$vuetify.breakpoint.smAndDown ? undefined : 760" :fullscreen="$vuetify.breakpoint.smAndDown" scrollable>
      <v-card>
        <v-card-title class="py-3 px-4" :style="{ background: dialogItem ? dialogItem.color : '#1976D2' }">
          <v-icon color="white" class="mr-2" size="20">{{ dialogItem ? dialogItem.icon : 'mdi-account' }}</v-icon>
          <span style="color:#fff; font-size:14px; font-weight:700;">{{ dialogItem ? dialogItem.label : '' }}</span>
          <v-spacer></v-spacer>
          <div class="period-tabs-dialog">
            <button v-for="p in periods" :key="p.key" class="period-btn-dialog"
              :class="{ active: activePeriod === p.key }"
              :style="activePeriod === p.key ? { background: 'rgba(255,255,255,0.3)', color: '#fff' } : { color: 'rgba(255,255,255,0.7)' }"
              @click="changePeriod(p.key)">
              {{ p.label }}
            </button>
          </div>
          <v-btn icon dark small @click="dialog = false" class="ml-1"><v-icon size="20">mdi-close</v-icon></v-btn>
        </v-card-title>

        <v-card-text class="pa-0">
          <div v-if="dialogLoading" class="pa-6 text-center">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </div>
          <v-simple-table v-else-if="dialogUsers.length > 0" dense>
            <thead>
              <tr>
                <th style="width:40px"></th>
                <th>{{ $t('table.name') }}</th>
                <th class="d-none d-sm-table-cell">Email</th>
                <th>{{ $t('table.last_login') }}</th>
                <th>Statusi</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="user in dialogUsers" :key="user.id">
                <td class="py-1">
                  <v-avatar size="30">
                    <v-img v-if="user.avatar" :src="user.avatar"></v-img>
                    <v-icon v-else size="18" color="grey lighten-1">mdi-account-circle</v-icon>
                  </v-avatar>
                </td>
                <td class="font-weight-medium" style="font-size:13px;">{{ user.name }}</td>
                <td class="text--secondary d-none d-sm-table-cell" style="font-size:12px;">{{ user.email }}</td>
                <td style="font-size:11px; white-space:nowrap;">
                  <span v-if="user.last_login_at">{{ formatDate(user.last_login_at) }}</span>
                  <span v-else class="grey--text">—</span>
                </td>
                <td>
                  <v-chip x-small :color="user.status_id === 1 ? 'success' : 'error'" dark>
                    {{ user.status_id === 1 ? 'Aktiv' : 'Jo' }}
                  </v-chip>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
          <div v-else class="pa-8 text-center grey--text">
            <v-icon size="44" color="grey lighten-2">mdi-account-off-outline</v-icon>
            <div class="mt-2 text-body-2">{{ $t('messages.no_data_for_period') }}</div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
export default {
  props: {
    stats: { type: Object, default: () => ({}) },
    loginActivity: { type: Object, default: () => ({}) },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      dialog: false,
      dialogLoading: false,
      dialogItem: null,
      dialogUsers: [],
      activePeriod: 'all',
      periods: [
        { key: 'all',   label: 'Të gjithë' },
        { key: 'today', label: 'Sot' },
        { key: 'week',  label: '7 ditë' },
        { key: 'month', label: '30 ditë' },
      ],
    }
  },
  computed: {
    items() {
      return [
        { label: 'Organizata',           icon: 'mdi-school',                 color: '#1976D2', roleId: 2, total: this.stats.totalSchools   ?? '—', todayLogins: this.loginActivity.organizations?.today ?? 0 },
        { label: 'Prindër / Kujdestarë', icon: 'mdi-account-group-outline',  color: '#7B1FA2', roleId: 4, total: this.stats.totalGuardians  ?? '—', todayLogins: this.loginActivity.parents?.today      ?? 0 },
        { label: 'Nxënës',               icon: 'mdi-badge-account-outline',  color: '#F57C00', roleId: 6, total: this.stats.totalStudents   ?? '—', todayLogins: this.loginActivity.students?.today     ?? 0 },
        { label: 'Shoferë',              icon: 'mdi-account-tie-hat-outline', color: '#388E3C', roleId: 3, total: this.stats.totalDrivers    ?? '—', todayLogins: this.loginActivity.drivers?.today      ?? 0 },
        { label: 'Drejtorë',             icon: 'mdi-account-star-outline',   color: '#e65100', roleId: 7, total: this.stats.totalDirectors  ?? '—', todayLogins: this.loginActivity.directors?.today    ?? 0 },
      ]
    },
  },
  methods: {
    openDialog(item) {
      this.dialogItem = item
      this.activePeriod = 'all'
      this.dialog = true
      this.fetchUsers(item.roleId, 'all')
    },
    changePeriod(period) {
      this.activePeriod = period
      this.fetchUsers(this.dialogItem.roleId, period)
    },
    fetchUsers(roleId, period) {
      this.dialogLoading = true
      this.dialogUsers = []
      axios.get('/admin-dashboard/users-by-role', { params: { role_id: roleId, period } })
        .then(res => { this.dialogUsers = res.data })
        .catch(() => { this.dialogUsers = [] })
        .finally(() => { this.dialogLoading = false })
    },
    formatDate(dt) {
      if (!dt) return '—'
      const d = new Date(dt)
      const now = new Date()
      const diff = Math.floor((now - d) / 60000)
      if (diff < 1) return 'tani'
      if (diff < 60) return diff + ' min më parë'
      if (diff < 1440) return Math.floor(diff / 60) + ' orë më parë'
      if (diff < 10080) return Math.floor(diff / 1440) + ' ditë më parë'
      return d.toLocaleDateString('sq-AL', { day: '2-digit', month: '2-digit', year: 'numeric' })
    },
  },
}
</script>

<style scoped>
.platform-card { border-radius: 14px !important; border: 1px solid rgba(0,0,0,0.06) !important; overflow: hidden; height: 100%; }
.platform-header { background: linear-gradient(90deg, #1565C0, #1976D2); padding: 14px 20px; }
.header-row { display: flex; align-items: center; gap: 10px; }
.header-icon { width: 28px; height: 28px; background: rgba(255,255,255,0.2); border-radius: 8px; display: flex; align-items: center; justify-content: center; }
.header-title { color: #fff; font-size: 14px; font-weight: 700; letter-spacing: 0.3px; }
.user-stat-row { display: flex; align-items: center; gap: 10px; padding: 9px 10px; border-radius: 10px; background: rgba(0,0,0,0.02); margin-bottom: 6px; cursor: pointer; transition: background 0.15s, transform 0.1s; }
.user-stat-row:hover { background: rgba(0,0,0,0.06); transform: translateX(2px); }
.user-stat-icon { width: 36px; height: 36px; border-radius: 9px; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
.user-stat-info { flex: 1; min-width: 0; }
.user-stat-label { font-size: 10px; color: #94a3b8; font-weight: 500; text-transform: uppercase; letter-spacing: 0.4px; }
.user-stat-value { font-size: 22px; font-weight: 800; line-height: 1.1; }
.user-stat-badge { flex-shrink: 0; }
.period-tabs-dialog { display: flex; gap: 3px; flex-wrap: wrap; }
.period-btn-dialog { padding: 3px 8px; border-radius: 12px; font-size: 10px; font-weight: 600; border: 1px solid rgba(255,255,255,0.3); background: transparent; cursor: pointer; transition: all 0.15s; white-space: nowrap; }

@media (max-width: 480px) {
  .user-stat-value { font-size: 20px; }
  .user-stat-icon { width: 32px; height: 32px; }
}
</style>
